let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4o1HB")).then(() => parcelRequire('16Suj'));